import { render } from "./Modal_Create_Departament.vue?vue&type=template&id=7740a06e"
import script from "./Modal_Create_Departament.vue?vue&type=script&lang=js"
export * from "./Modal_Create_Departament.vue?vue&type=script&lang=js"

import "./Modal_Create_Departament.vue?vue&type=style&index=0&id=7740a06e&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__